import { useQuery } from "@tanstack/react-query";
import { Container } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { getAuthMethod } from "../../modules/helper";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import Filter from "./components/Filter";
import TableShipments from "./components/TableShipments";
import PaginateCard from "../../components/PaginateCard";
import ExcelShipments from "./components/ExcelShipments";

function Shipments() {
  const {
    data,
    isFetching: isLoading,
    refetch,
  } = useQuery({
    queryKey: ["listShipments"],
    queryFn: () =>
      getAuthMethod(
        "/supervisor/v1/shipments",
        Object.fromEntries([...searchParams])
      ).then(res => res.data.result),
    refetchOnWindowFocus: false,
  });

  const [searchParams, setSearchParams] = useSearchParams({
    items: 10,
    page: 1,
  });

  const set = ({ label, value }) => {
    setSearchParams(cur => {
      if (!value || value === "0") {
        delete cur.delete(label);
      } else {
        cur.set(label, value);
      }
      return cur;
    });
  };

  return (
    <MainMenu>
      <Container>
        <h5 className="mb-3">لیست مرسولات</h5>

        <Filter
          searchParams={searchParams}
          set={set}
          isLoading={isLoading}
          get={() => {
            set({ label: "page", value: 1 });
            refetch();
          }}
        />

        <TableShipments
          shipments={data?.shipments}
          count={data?.count}
          isLoading={isLoading}
          page={searchParams.get("page")}
          items={searchParams.get("items")}
        />

        <section>
          <PaginateCard
            count={data?.count}
            numberItems={parseInt(searchParams.get("items"))}
            numberPage={parseInt(searchParams.get("page"))}
            onIndexChoose={number => {
              set({ label: "page", value: number });
              refetch();
            }}
          />
        </section>

        <section>
          <ExcelShipments params={Object.fromEntries([...searchParams])} />
        </section>
      </Container>
    </MainMenu>
  );
}

export default Shipments;
